import Vue from 'vue';
export const SaveIcon = Vue.extend({
    functional: true,
    name: 'SaveIcon',
    render(createElement, ctx) {
        return (<svg viewBox="0 0 48 48">
                <polygon fill="#fff" points="40.6,12.1 17,35.7 7.4,26.1 4.6,29 17,41.3 43.4,14.9"/>
            </svg>);
    },
});
//# sourceMappingURL=SaveIcon.jsx.map